import { BaseText, Button } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';

type StopParkingChargingProps = {
  handleStopParkingAndChargingSessions: () => void;
  continueParking: () => void;
  loading: boolean;
};

const StopParkingCharging: React.FC<StopParkingChargingProps> = ({
  handleStopParkingAndChargingSessions,
  continueParking,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledWrapper mb={25}>
        <BaseText testID="stop-parking-and-charging-confirm-text">
          {t('parking.stopParkingAndCharging')}
        </BaseText>
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <Button
          size="l"
          testID="parking-and-charging-stop-confirm"
          text={t('button.stopParkingAndCharging')}
          onPress={() => handleStopParkingAndChargingSessions()}
          disabled={loading}
          loading={loading}
        />
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <Button
          size="l"
          testID="parking-and-charging-continue-parking"
          buttonType="tertiary"
          text={t('parking.continueParking')}
          onPress={() => continueParking()}
          disabled={loading}
          loading={loading}
        />
      </StyledWrapper>
    </>
  );
};

export default StopParkingCharging;
